import {
  Box,
  Button,
  Flex,
  Stack,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';

import { ColorModeSwitcher } from '../components/presentational/ColorModeSwitcher';
import { GMModeSwitcher } from '../components/connected/GMModeSwitcher';
import { CreditsModal } from '../components/presentational/License';
import {
  ContentAccordion,
  HeaderAccordion,
} from '../components/connected/ContentAccordion';

export function SingleCharacterView() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Flex flexDir="column" alignItems="center" minH="100vh" p={3}>
        <Stack
          direction={{ base: 'column-reverse', md: 'row' }}
          alignItems="center"
          position="absolute"
          right="0"
          top="0"
          spacing={0}
        >
          <GMModeSwitcher
            _hover={{ backgroundColor: 'rgba(255,255,255, 0.1)' }}
          />
          <ColorModeSwitcher
            _hover={{ backgroundColor: 'rgba(255,255,255, 0.1)' }}
          />
        </Stack>
        <HeaderAccordion />
        <Box rounded="lg" p={5} flex="1" w="full" layerStyle="base">
          <ContentAccordion />
        </Box>
        <Box mt={1} p={2} alignSelf="end">
          <Button
            size="sm"
            onClick={onOpen}
            color="white"
            bg={useColorModeValue('teal.500', 'teal.700')}
            _hover={{
              backgroundColor: useColorModeValue('teal.600', 'teal.600'),
            }}
          >
            Credits
          </Button>
        </Box>
      </Flex>
      <CreditsModal isOpen={isOpen} onClose={onClose} />
    </>
  );
}
